import React, { useMemo } from "react";
import { FiDownload } from "react-icons/fi";
import { useTranslation } from "react-i18next";


import { openS3Document } from "../lib/documents";

function FinancialCalendar() {
  const { t } = useTranslation();

  const files = useMemo(
    () => [
      {
        name: t("main.financialCalendar.documents.calendar2026"),
        key: "financial_calendar/2026/financial_calendar_rigsavespa_2026.pdf",
      },
      {
        name: t("main.financialCalendar.documents.calendar2025"),
        key: "financial_calendar/2025/financial_calendar_rigsavespa_2025.pdf",
      },
      {
        name: t("main.financialCalendar.documents.calendar2024"),
        key: "financial_calendar/2024/Financial_Calendar-RIGSAVE-SPA.pdf",
      },
    ],
    [t]
  );

  const upcomingEvents = useMemo(
    () => [
      {
        title: t("main.financialCalendar.events.annualGeneralMeeting"),
        date: t("main.financialCalendar.dates.april2026"),
      },
      {
        title: t("main.financialCalendar.events.auditedAnnualStatement"),
        date: t("main.financialCalendar.dates.june2026"),
      },
      {
        title: t("main.financialCalendar.events.halfYearStatement"),
        date: t("main.financialCalendar.dates.october2026"),
      },
      {
        title: t("main.financialCalendar.events.deutscheEigenkapitalforum"),
        date: t("main.financialCalendar.dates.november2026"),
      },
    ],
    [t]
  );

  const pastEvents = useMemo(
    () => [
      {
        title: t("main.financialCalendar.past.event1.title"),
        place: t("main.financialCalendar.past.event1.place"),
        date: t("main.financialCalendar.past.event1.date"),
      },
      {
        title: t("main.financialCalendar.past.event2.title"),
        place: t("main.financialCalendar.past.event2.place"),
        date: t("main.financialCalendar.past.event2.date"),
      },
    ],
    [t]
  );

  return (
    <main className="calendar-page">
      <section className="calendar-hero">
        <div>
          <h1>{t("main.financialCalendar.title")}</h1>
          <span />
        </div>
      </section>

      <section className="upcoming-section">
        <div className="calendar-container">
          <h2>{t("main.financialCalendar.upcomingEvents")}</h2>

          <div className="upcoming-events-grid">
            {upcomingEvents.map((event) => (
              <div
                className="upcoming-card"
                key={`${event.title}-${event.date}`}
              >
                <h3>{event.title}</h3>
                <p>{event.date}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="past-events-section">
        <div className="calendar-container">
          <h2>{t("main.financialCalendar.pastEvents")}</h2>

          <div className="past-events-row">
            {pastEvents.map((event) => (
              <div className="event-card" key={`${event.title}-${event.date}`}>
                <h3>{event.title}</h3>
                {event.place ? <p>{event.place}</p> : null}
                <p>{event.date}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="calendar-documents-section">
        <div className="calendar-documents-container">
          <h2>{t("main.financialCalendar.documentsTitle")}</h2>

          <div className="calendar-documents-list">
            {files.map((pdf) => (
              <div className="calendar-document-row" key={pdf.key}>
                <span>{pdf.name}</span>

                <a
                  href="/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${t(
                    "main.financialCalendar.download"
                  )} ${pdf.name}`}
                  onClick={(event) => openS3Document(event, pdf.key)}
                >
                  <FiDownload />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default FinancialCalendar;